(() => {
  const pad = (n) => String(n).padStart(2, "0");
  let timerId = null;
  const scrollRafByTrack = new WeakMap();

  const formatRemaining = (seconds) => {
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (days > 0) return `${days}d ${pad(hours)}h`;
    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
  };

  const tick = () => {
    const widgets = document.querySelectorAll("[data-offer-ends-in]");
    if (!widgets.length) return;

    const now = Math.floor(Date.now() / 1000);

    widgets.forEach((el) => {
      if (el.dataset.endsInDisabled === "true") return;

      const out = el.querySelector("[data-countdown-output]");
      const timeNode = out ? out.querySelector(".offers-widget__ends-in-time") : null;
      if (!out || !timeNode) return;

      const target = parseInt(el.dataset.targetEpoch || "", 10);
      if (!Number.isFinite(target) || target <= 0) {
        timeNode.textContent = "Set end date";
        return;
      }

      const remaining = target - now;
      if (remaining <= 0) {
        el.setAttribute("data-countdown-ended", "true");
        el.hidden = true;
        return;
      }

      timeNode.textContent = formatRemaining(remaining);
    });
  };

  const initArrows = () => {
    const tracks = document.querySelectorAll("[data-offers-track]");
    tracks.forEach((track) => {
      const section = track.closest(".offers-widget");
      if (!section) return;

      const prevBtn = section.querySelector("[data-offers-prev]");
      const nextBtn = section.querySelector("[data-offers-next]");
      if (!prevBtn || !nextBtn) return;

      const getStep = () => {
        const card = track.querySelector(".offers-widget__card:not([hidden])") || track.querySelector(".offers-widget__card");
        const trackStyles = window.getComputedStyle(track);
        const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || "16") || 16;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      };

      const syncButtons = () => {
        const maxLeft = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = track.scrollLeft >= maxLeft;
      };

      prevBtn.addEventListener("click", () => {
        track.scrollBy({ left: -getStep(), behavior: "smooth" });
      });

      nextBtn.addEventListener("click", () => {
        track.scrollBy({ left: getStep(), behavior: "smooth" });
      });

      track.addEventListener(
        "scroll",
        () => {
          if (scrollRafByTrack.get(track)) return;
          const rafId = window.requestAnimationFrame(() => {
            syncButtons();
            scrollRafByTrack.delete(track);
          });
          scrollRafByTrack.set(track, rafId);
        },
        { passive: true }
      );

     window.addEventListener("resize", syncButtons);
      syncButtons();
    });
  };

  const startTimer = () => {
    if (timerId) return;
    tick();
    timerId = window.setInterval(tick, 1000);
  };

  const stopTimer = () => {
    if (!timerId) return;
    window.clearInterval(timerId);
    timerId = null;
  };

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stopTimer();
    } else {
      startTimer();
    }
  });

  initArrows();
  startTimer();
})();